import axios from "axios";
import { STORE_BASE_URL } from "../BaseURL";
import getHeaders from "../../constants/headers";

export const addFranchise = (brandId, data) => {
  return axios({
    method: "post",
    url:
      STORE_BASE_URL + "/brand/api/secure/v1/brand/" + brandId + "/franchise", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getFranchise = (brandId) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL + "/brand/api/secure/v1/brand/" + brandId + "/franchise", // for android use
    headers: getHeaders(),
  });
};

export const updateFranchise = (brandId, data) => {
  return axios({
    method: "put",
    url:
      STORE_BASE_URL + "/brand/api/secure/v1/brand/" + brandId + "/franchise", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getFranchiseStoreMappedList = (brandId, franchiseId) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL + "/brand/api/secure/v1/brand/" + brandId + "/franchise/" + franchiseId + "/store", // for android use
    headers: getHeaders(),
  });
};

export const addFranchiseStoreMap = (brandId, franchiseId, data) => {
  return axios({
    method: "post",
    url:
      STORE_BASE_URL +
      "/brand/api/secure/v1/brand/" +
      brandId +
      "/franchise/" +
      franchiseId +
      "/store", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateFranchiseStoreMap = (brandId, franchiseId, data) => {
  return axios({
    method: "put",
    url:
      STORE_BASE_URL +
      "/brand/api/secure/v1/brand/" +
      brandId +
      "/franchise/" +
      franchiseId +
      "/store", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getFranchiseRateList = (brandId, franchiseId) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL +
      "/brand/api/secure/v1/brand/" +
      brandId +
      "/franchise/" +
      franchiseId +
      "/rate", // for android use
    headers: getHeaders(),
  });
};

export const getFranchiseCalculationMode = (brandId) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL +
      "/brand/api/secure/v1/brand/" +
      brandId +
      "/calculation-mode",
    headers: getHeaders(),
  });
};

export const addFranchiseRate = (brandId, franchiseId, data) => {
  return axios({
    method: "post",
    url:
      STORE_BASE_URL +
      "/brand/api/secure/v1/brand/" +
      brandId +
      "/franchise/" +
      franchiseId +
      "/rate", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateFranchiseRate = (brandId, franchiseId, data) => {
  return axios({
    method: "put",
    url:
      STORE_BASE_URL +
      "/brand/api/secure/v1/brand/" +
      brandId +
      "/franchise/" +
      franchiseId +
      "/rate", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getFranchiseAvailableStore = (brandId) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL +
      "/brand/api/secure/v1/brand/" +
      brandId +
      "/franchise-available-store", // for android use
    headers: getHeaders(),
  });
};


export const getFranchiseUserList = (brandId, franchiseId) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL +
      "/brand/api/secure/v1/brand/" +
      brandId +
      "/franchise/" +
      franchiseId +
      "/user", // for android use
    headers: getHeaders(),
  });
};

export const addFranchiseUser = (brandId, franchiseId, data) => {
  return axios({
    method: "post",
    url:
      STORE_BASE_URL +
      "/brand/api/secure/v1/brand/" +
      brandId +
      "/franchise/" +
      franchiseId +
      "/user", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateFranchiseUser = (brandId, franchiseId, data) => {
  return axios({
    method: "put",
    url:
      STORE_BASE_URL +
      "/brand/api/secure/v1/brand/" +
      brandId +
      "/franchise/" +
      franchiseId +
      "/user", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getFranchiseAvailableUser = (brandId) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL +
      "/brand/api/secure/v1/brand/" +
      brandId +
      "/franchise-available-user",
    headers: getHeaders(),
  });
};

export const getFranchiseUserInfo = (userId) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL +
      "/brand/api/secure/v1/franchise-user/" +
      userId +
      "/franchise",
    headers: getHeaders(),
  });
};

export const getFranchiseUserStore = (userId) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL +
      "/brand/api/secure/v1/franchise-user/" +
      userId +
      "/franchise-store",
    headers: getHeaders(),
  });
};

export const getFranchiseRate = (userId) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL +
      "/brand/api/secure/v1/franchise-user/" +
      userId +
      "/franchise-rate",
    headers: getHeaders(),
  });
};

export const getFranchiseStoreOrderRevenue = (data) => {
  return axios({
    method: "post",
    url:
      STORE_BASE_URL +
      "/store/api/secure/v1/store-order-revenue",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getFranchiseStoreServiceWiseRevenue = (data) => {
  return axios({
    method: "post",
    url:
      STORE_BASE_URL +
      "/store/api/secure/v2/store-service-wise-revenue",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};